import { render, staticRenderFns } from "./order-extra-modal.vue?vue&type=template&id=0b38edc0&"
import script from "./order-extra-modal.vue?vue&type=script&lang=js&"
export * from "./order-extra-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports